import { Locale } from "../Locale.js";
import { getPathInLocale } from "./getPathInLocale.js";

export function getCartPath(locale: Locale): string {
	return getPathInLocale(locale, {
		[Locale.cs]: "/kosik",
	});
}
